import TemplateView from '../../../../TemplateView'
import {ReportType} from '../../../constants'
import {isReportAvailable} from '../utils'

export default class ChooseReportSection extends TemplateView {
    constructor({
        reportNameKeys = {},
        tabSelected = () => {},
    }) {
        super()

        this.params = {
            reportNameKeys,
            tabSelected,
        }

        this.state = {
            selectedType: null,
            userRights: {},
            features: {},
        }

        this.timeReports = [
            ReportType.STAFF_PERFORMANCE,
            ReportType.OVERTIME,
            ReportType.LEAVE_TIME,
            ReportType.WORK_STATUSES,
            ReportType.TIME_TRACK,
            ReportType.TIME_TRACK_IN_DETAIL,
            ReportType.ESTIMATED_VS_ACTUAL,
            ReportType.TIME_CARDS,
        ]

        this.billingReports = [
            ReportType.BILLING_SUMMARY,
            ReportType.INVOICING,
            ReportType.COST_OF_WORK,
            ReportType.PROFIT_LOSS,
        ]

        this.customDataReports = [
            ReportType.CUSTOM_FIELDS,
        ]

        this.onStatePropertyChanged('selectedType', (selectedType) => {
            Object.keys(this.$buttons).map((type) => {
                this.$buttons[type].toggleClass('pressed', selectedType === type)
            })
        })

        this.onStatePropertyChanged('userRights', () => {
            this.$buttons[ReportType.STAFF_PERFORMANCE].toggle(this._isTabShown(ReportType.STAFF_PERFORMANCE))
            this.$buttons[ReportType.OVERTIME].toggle(this._isTabShown(ReportType.OVERTIME))
            this.$buttons[ReportType.LEAVE_TIME].toggle(this._isTabShown(ReportType.LEAVE_TIME))
            this.$buttons[ReportType.TIME_TRACK].toggle(this._isTabShown(ReportType.TIME_TRACK))
            this.$buttons[ReportType.TIME_TRACK_IN_DETAIL].toggle(this._isTabShown(ReportType.TIME_TRACK_IN_DETAIL))
            this.$buttons[ReportType.ESTIMATED_VS_ACTUAL].toggle(this._isTabShown(ReportType.ESTIMATED_VS_ACTUAL))
            this.$buttons[ReportType.BILLING_SUMMARY].toggle(this._isTabShown(ReportType.BILLING_SUMMARY))
            this.$buttons[ReportType.INVOICING].toggle(this._isTabShown(ReportType.INVOICING))
            this.$buttons[ReportType.COST_OF_WORK].toggle(this._isTabShown(ReportType.COST_OF_WORK))
            this.$buttons[ReportType.PROFIT_LOSS].toggle(this._isTabShown(ReportType.PROFIT_LOSS))
            this.$buttons[ReportType.CUSTOM_FIELDS].toggle(this._isTabShown(ReportType.CUSTOM_FIELDS))
            this.$buttons[ReportType.WORK_STATUSES].toggle(this._isTabShown(ReportType.WORK_STATUSES))
            this.$buttons[ReportType.TIME_CARDS].toggle(this._isTabShown(ReportType.TIME_CARDS))

            const showTimeReports = this.timeReports.map((type) => this._isTabShown(type)).reduce((acc, value) => acc || value, false)
            this.find('.timeReports').toggle(showTimeReports)

            const showBillingReports = this.billingReports.map((type) => this._isTabShown(type)).reduce((acc, value) => acc || value, false)
            this.find('.billingReports').toggle(showBillingReports)

            const showCustomDataReports = this.customDataReports.map((type) => this._isTabShown(type)).reduce((acc, value) => acc || value, false)
            this.find('.customDataReports').toggle(showCustomDataReports)
        })
    }

    templateHtml() {
        return '<div class="indexContent">' +
               '  <div class="timeReports">' +
               '    <div class="indexHeader"><%-firstCategoryHeader%></div>' +
               '    <div class="staffButton reportButton"><%-staff%></div>' +
               '    <div class="overtimeButton reportButton"><%-overtime%></div>' +
               '    <div class="balancesButton reportButton"><%-balance%></div>' +
               '    <div class="workStatusesButton reportButton"><%-work_statuses%></div>' +
               '    <div class="newTimeTrackButton reportButton"><%-newTimetrack%></div>' +
               '    <div class="timeTrackButton reportButton"><%-timetrack%></div>' +
               '    <div class="evaButton reportButton"><%-eva%></div>' +
               '    <div class="timeCardsButton reportButton"><%-time_cards%></div>' +
               '  </div>' +
               '  <div class="billingReports">' +
               '    <div class="indexHeader"><%-secondCategoryHeader%></div>' +
               '    <div class="billingButton reportButton"><%-billing%></div>' +
               '    <div class="invoiceButton reportButton"><%-invoice%></div>' +
               '    <div class="costOfWorkButton reportButton"><%-cost%></div>' +
               '    <div class="profitLossButton reportButton"><%-profit_loss%></div>' +
               '  </div>' +
               '  <div class="customDataReports">' +
               '    <div class="indexHeader"><%-thirdCategoryHeader%></div>' +
               '    <div class="customFieldsButton reportButton"><%-custom_fields%></div>' +
               '  </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            firstCategoryHeader: 'saved_reports.category.time',
            secondCategoryHeader: 'saved_reports.category.money',
            thirdCategoryHeader: 'saved_reports.category.custom_data',

            staff: this.params.reportNameKeys[ReportType.STAFF_PERFORMANCE],
            overtime: this.params.reportNameKeys[ReportType.OVERTIME],
            balance: this.params.reportNameKeys[ReportType.LEAVE_TIME],
            newTimetrack: 'report.newTimetrack.title',
            timetrack: this.params.reportNameKeys[ReportType.TIME_TRACK_IN_DETAIL],
            eva: this.params.reportNameKeys[ReportType.ESTIMATED_VS_ACTUAL],
            billing: this.params.reportNameKeys[ReportType.BILLING_SUMMARY],
            invoice: this.params.reportNameKeys[ReportType.INVOICING],
            cost: this.params.reportNameKeys[ReportType.COST_OF_WORK],
            profit_loss: this.params.reportNameKeys[ReportType.PROFIT_LOSS],

            work_statuses: 'report.work_statuses',
            custom_fields: 'report.custom_fields.title',
            time_cards: 'report.time_cards.title',
        }
    }

    afterRender() {
        this.$buttons = {}
        this.$buttons[ReportType.STAFF_PERFORMANCE] = this.find('.staffButton')
        this.$buttons[ReportType.OVERTIME] = this.find('.overtimeButton')
        this.$buttons[ReportType.LEAVE_TIME] = this.find('.balancesButton')
        this.$buttons[ReportType.TIME_TRACK] = this.find('.newTimeTrackButton')
        this.$buttons[ReportType.TIME_TRACK_IN_DETAIL] = this.find('.timeTrackButton')
        this.$buttons[ReportType.ESTIMATED_VS_ACTUAL] = this.find('.evaButton')
        this.$buttons[ReportType.BILLING_SUMMARY] = this.find('.billingButton')
        this.$buttons[ReportType.INVOICING] = this.find('.invoiceButton')
        this.$buttons[ReportType.COST_OF_WORK] = this.find('.costOfWorkButton')
        this.$buttons[ReportType.PROFIT_LOSS] = this.find('.profitLossButton')
        this.$buttons[ReportType.CUSTOM_FIELDS] = this.find('.customFieldsButton')
        this.$buttons[ReportType.WORK_STATUSES] = this.find('.workStatusesButton')
        this.$buttons[ReportType.TIME_CARDS] = this.find('.timeCardsButton')

        Object.keys(this.$buttons).map((type) => {
            this.$buttons[type].click(() => this.params.tabSelected(type))
        })
    }

    _isTabShown(type) {
        return isReportAvailable(type, this.state.userRights, this.state.features)
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/dashboard/createReportPopup/components/ChooseReportSection.js